import { loyaltySelectors } from './models/loyalty';
import { orderingSelectors } from './models/ordering';

export const selectors = {
  loyalty: loyaltySelectors,
  ordering: orderingSelectors,
};
